import { Controller } from "@hotwired/stimulus"

// Reloads the turbo frame around it while a background work runs: the frame's
// next answer drops this controller once the work is over.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 2000 } }

  connect() {
    this.timer = setTimeout(() => this.reload(), this.intervalValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  reload() {
    const frame = this.element.closest("turbo-frame")
    if (!frame) return
    if (frame.getAttribute("src") === this.urlValue) frame.reload()
    else frame.src = this.urlValue
  }
}
